<template>
  <!-- ヘッダー -->
  <DbsHeader
    header-title="予約内容"
    :click-back-button-event="backToDbsIndexPage"
  />

  <div class="content-block">
    <p class="park-title">{{ park.park_info.park_name_jp }}</p>
    <CycleInfo label="バイク番号" :value="cycle.cyc_name" />
    <CycleInfo label="予約有効期限" :value="reservation.reserve_limit" />
  </div>

  <div class="link-buttons">
    <div class="block">
      <DbsHowToUseLinkButton />
    </div>
  </div>

  <DbsMyBookingBottomButtons />
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateDbsMyBooking",
  setup() {
    const store = useStore();

    const cycle = store.getters["dbs/cycle"];
    const park = store.getters["dbs/park"];
    const reservation = store.getters["dbs/reservation"];

    const backToDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsWithClose();
    };

    return {
      cycle,
      park,
      reservation,
      backToDbsIndexPage,
    };
  },
};
</script>
<style scoped>
.content-block {
  width: 100%;
  padding: 0 10px 16px;
  margin-bottom: 30px;
}
.park-title {
  font-size: 14px;
  font-weight: bold;
  margin: 10px;
}
.coupon-block {
  width: 100%;
  margin-bottom: 30px;
}
.block-title {
  font-size: 16px;
  font-weight: bold;
  margin: 14px;
}
.link-buttons {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 160px;
}
.link-buttons .block {
  padding: 10px;
}
</style>
